import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as _ from 'lodash';
import { Common } from '../common';
import { Configuration } from '../models/configuration.model';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private favIcon: any = document.querySelector('#favIcon');
  private configuration: Configuration;

  constructor(
    private titleService: Title,
    private appConfigService: AppConfigService) {
    this.configuration = this.appConfigService.getConfig().defaultConfiguration;

    this.setConfigurationDependants();
  }

  public setConfiguration(configuration: Configuration) {
    this.configuration = configuration;

    this.setConfigurationDependants();
  }

  public getNavLogoUrl(): string {
    return this.configuration.navLogoUrl;
  }

  public getNavTitle(): string {
    return this.configuration.navTitle;
  }

  public getFooterText(): string {
    return this.configuration.footerText;
  }

  public getHowCanWeHelpText(): string {
    return this.configuration.howCanWeHelpText;
  }

  public getCircleGaugeColour(): string {
    return this.configuration.graphValueColour;
  }

  public getPaymentFormCompanyName(): string {
    return this.configuration.paymentFormCompanyName;
  }

  public isCollexusVersion(): boolean {
    return this.appConfigService.getConfig().htmlVersion !== 'version1';
  }

  private setConfigurationDependants(): void {
    // Update the properties that aren't set automatically by reactive references

    if (Common.stringHasValue(this.configuration.title)) {
      this.titleService.setTitle(this.configuration.title);
    }

    if (Common.stringHasValue(this.configuration.favIcon)) {
      this.favIcon.href = this.configuration.favIcon;
    }

    this.updateDynamicStyle();
  }

  private updateDynamicStyle(): void {
    const cssElements: string[] = [];

    if (!_.isNil(this.configuration.backgroundColour) && this.configuration.backgroundColour !== '') {
      cssElements.push(`body {background-color: ${this.configuration.backgroundColour} !important;}`);
    }

    if (!_.isNil(this.configuration.buttonPrimaryColour) && this.configuration.buttonPrimaryColour !== '') {
      cssElements.push(`.button-primary, .button-green {color: ${this.configuration.buttonPrimaryColour} !important;}`);
    }

    if (!_.isNil(this.configuration.buttonPrimaryBackgroundColour) && this.configuration.buttonPrimaryBackgroundColour !== '') {
      cssElements.push(
        `.button-primary, .button-green {background: ${this.configuration.buttonPrimaryBackgroundColour} !important; 
        background-color: ${this.configuration.buttonPrimaryBackgroundColour} !important;}`);
    }

    if (!_.isNil(this.configuration.buttonPreviousColour) && this.configuration.buttonPreviousColour !== '') {
      cssElements.push(`.button-previous {color: ${this.configuration.buttonPreviousColour} !important;}`);
    }

    if (!_.isNil(this.configuration.buttonPreviousBackgroundColour) && this.configuration.buttonPreviousBackgroundColour !== '') {
      cssElements.push(
        `.button-previous {background: ${this.configuration.buttonPreviousBackgroundColour} !important; 
        background-color: ${this.configuration.buttonPreviousBackgroundColour} !important;}`);
    }

    if (!_.isNil(this.configuration.buttonToggleColour) && this.configuration.buttonToggleColour !== '' && this.configuration.buttonToggleBackgroundColour &&
      this.configuration.buttonToggleBackgroundColour !== '') {
      cssElements.push(
        `.k-button.k-toggle-button {color: ${this.configuration.buttonToggleColour} !important; background-color: inherit !important;
        border-color: ${this.configuration.buttonToggleColour} !important;}
        .k-button.k-toggle-button.k-state-selected {color: ${this.configuration.buttonToggleBackgroundColour} !important;
        background-color: ${this.configuration.buttonToggleColour} !important; border-color: ${this.configuration.buttonToggleColour} !important;}`);
    }

    if (!_.isNil(this.configuration.graphNoValueColour) && this.configuration.graphNoValueColour !== '') {//TODO: Not working, need to fix?
      cssElements.push(`.k-progressbar {background-color: ${this.configuration.graphNoValueColour} !important;}`);
    }

    if (!_.isNil(this.configuration.graphValueColour) && this.configuration.graphValueColour !== '') {
      cssElements.push(`.k-progressbar .k-state-selected {background-color: ${this.configuration.graphValueColour} !important;}`);
    }

    if (!_.isNil(this.configuration.checkboxColour) && this.configuration.checkboxColour !== '') {
      cssElements.push(`.k-checkbox:checked, .k-checkbox.k-checked {background-color: ${this.configuration.checkboxColour} !important;}`);
    }

    if (!_.isNil(this.configuration.wizardStepColour) && this.configuration.wizardStepColour !== '') {
      cssElements.push(`.wizard-step {color: ${this.configuration.wizardStepColour} !important;}`);
    }

    if (!_.isNil(this.configuration.wizardStepToDoColour) && this.configuration.wizardStepToDoColour !== '') {
      cssElements.push(`.wizard-step-to-do {color: ${this.configuration.wizardStepToDoColour} !important;}`)
    }

    const cssString = cssElements.join(' ');

    const styleElement: any = document.querySelector('#dynamicStyle');
    styleElement.innerHTML = cssString;
    let temp = '';
  }
}
